"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../shared/BaseTailoringQuestions";

interface DepreciationTailoringQuestionsProps {
  onBack?: () => void;
}

export default function DepreciationTailoringQuestions({ onBack }: DepreciationTailoringQuestionsProps) {
  const questions: TailoringQuestion[] = [
    {
      id: "Depr-1",
      question: "Which method of depreciation is followed by the entity?",
      type: "radio",
      options: ["Straight-line method", "Written Down Value method", "Any other"],
      follow_up: {
        condition: "Any other",
        id: "Depr-1-doc",
        question: "Document only if Any other",
        type: "document"
      }
    },
    {
      id: "Depr-2",
      question: "Is there any significant degree of estimation uncertainty involved in any of the assumptions (i.e. method of depreciation, useful life, residual value) based on the following factors (as per SA 540 – Auditing Accounting Estimates, Including Fair Value Accounting Estimates, And Related Disclosures):\n\ni. Accounting estimates that are frequently made and updated because they relate to routine transactions.\n\nii. Accounting estimates derived from data that is readily available.\n\niii. Accounting estimates arising in entities that engage in business activities that are not complex.",
      type: "radio",
      options: ["Yes", "No"],
      follow_up: {
        condition: "Yes",
        id: "Depr-2-doc",
        question: "Document only if yes",
        type: "document"
      }
    },
    {
      id: "Depr-3",
      question: "Is there any significant management bias involved in any of the assumptions (i.e. method of depreciation, useful life, residual value)?",
      type: "radio",
      options: ["Yes", "No"],
      follow_up: {
        condition: "Yes",
        id: "Depr-3-doc",
        question: "Document only if yes",
        type: "document"
      }
    },
    {
      id: "Depr-4",
      question: "Has the management used any expert in arriving at the estimate?",
      type: "radio",
      options: ["Yes", "No"],
      follow_up: {
        condition: "Yes",
        id: "Depr-4-doc",
        question: "Document only if Yes",
        type: "document"
      }
    },
    {
      id: "Depr-5",
      question: "Which procedure has the ET assessed as a suitable procedure to address the identified risk(s) of material misstatements (including plausibility of relationship, if required)?",
      type: "radio",
      options: ["Recomputation", "Substantive Analytical Procedure"]
    }
  ];

  return (
    <BaseTailoringQuestions
      areaName="Depreciation"
      title="Depreciation - Tailoring Questions"
      description="Customize the audit program for Depreciation."
      questions={questions}
      onBack={onBack}
    />
  );
}
